export default "__VITE_ASSET__DQmpePOU__"